<template>
    <div class="valueWithCurrency">
        <div class="vwcCurrency">{{ currencyValue }}</div>
        <div class="vwcPrice">{{ priceValue }}</div>
    </div>
</template>

<script>
import StockHtmlHelper from '../stocks/StockHtmlHelper';

export default {
    props: {
        currency: { type: String, required: true },
        price: { type: Number, required: true },
        showCurrency: { type: Boolean, default: true }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        currencyValue() {
            return this.showCurrency ? this.currency.toUpperCase() : '';
        },
        priceValue() {
            return this.stockHtmlHelper.formatPriceWithLocaleCurrency(this.price, this.currency, this.$i18n.locale)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.valueWithCurrency {
    display: flex;
    align-items: center;
    gap: 5px;
    .vwcCurrency {
        flex: 1;
        font-size: 0.7em;
        color: #777;
    }
    .vwcPrice {
        font-weight: bold;
    }

    @media screen and (max-width: $small) {
        & {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.9em;
            gap: 2px;
            .vwcPrice {
                flex: 1;
            }
        }
    }
}
</style>